import { z } from 'zod'

export const GetCompanySettingsResponseSchema = z
  .object({
    id: z.string(),
    dayStart: z.number(),
    nightStart: z.number(),
    officeDaySummerComfortStart: z.number(),
    officeDaySummerComfortEnd: z.number(),
    officeDayWinterComfortStart: z.number(),
    officeDayWinterComfortEnd: z.number(),
    officeNightSummerComfortStart: z.number(),
    officeNightSummerComfortEnd: z.number(),
    officeNightWinterComfortStart: z.number(),
    officeNightWinterComfortEnd: z.number(),
    roomDaySummerComfortStart: z.number(),
    roomDaySummerComfortEnd: z.number(),
    roomDayWinterComfortStart: z.number(),
    roomDayWinterComfortEnd: z.number(),
    roomNightSummerComfortStart: z.number(),
    roomNightSummerComfortEnd: z.number(),
    roomNightWinterComfortStart: z.number(),
    roomNightWinterComfortEnd: z.number(),
    percentageThresholdCold: z.number(),
    percentageThresholdHot: z.number(),
    winterMonthStart: z.number(),
    summerMonthStart: z.number(),
    thresholdFrostProtection: z.number(),
    percentageThresholdFrostProtection: z.number(),
    co2ThresholdFair: z.number(),
    co2ThresholdPoor: z.number(),
    tvocThresholdFair: z.number(),
    tvocThresholdPoor: z.number(),
    humidityThresholdPoorMin: z.number(),
    humidityThresholdFairMin: z.number(),
    humidityThresholdFairMax: z.number(),
    humidityThresholdPoorMax: z.number(),
    percentageThresholdAirQuality: z.number(),
    // Sections de sidebar masquées, par use case : { energy: ['drift', 'heatPump'] }.
    // Clé en `z.string()` et non `z.nativeEnum(UseCase)` : une clé enum produirait un Record
    // complet (toutes les clés requises) et ferait échouer le parse. La validation stricte des
    // ids se fait à l'écriture, côté PUT.
    sidebarHiddenSections: z.record(z.string(), z.array(z.string())).default({}),
  })
  .nullable()
  .optional()

export type GetCompanySettingsResponse = z.infer<typeof GetCompanySettingsResponseSchema>
